export const AUTH_EXPIRED_EVENT = 'auth:expired';

export function emitAuthExpired() {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(AUTH_EXPIRED_EVENT));
}
